import { apiPost } from '../standardApi';

export async function apiGetPayment(dataToSend) {

  return await apiPost(
    `/Payment/CreatePaymentOrder`,
    JSON.stringify(dataToSend),
    'application/json'
  );
}

export async function apiPostConsentement(body) {
  const response = await apiPost(
    `/Payment/DebitUserConsent`,
    JSON.stringify({ ...body }),
    '',
    'application/json'
  );
  
  return response;
}
